import { gql } from '@apollo/client';

export default gql`
  mutation exitRoomInPositioningSession($sessionId: UUID!, $bracelets: [String!]!, $roomId: Long!) {
    exitRoomInPositioningSession(sessionId: $sessionId, bracelets: $bracelets, roomId: $roomId)
  }
`;
